import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";


import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "../../components/SoftBox";

// Custom styles for the SidenavCollapse
import {collapseIcon, collapseIconBox, collapseItem, collapseText,} from "./styles/sidenavCollapse";

// Soft UI Dashboard React context
import {useRayzayUIController} from "../../context";

function SidenavCollapse({
                             color = "info",
                             icon,
                             name,
                             children,
                             active = false,
                             noCollapse = false,
                             open = false,
                             route = "",
                             href = "",
                             ...rest
                         }) {
  const [controller] = useRayzayUIController();
  const { miniSidenav, transparentSidenav } = controller;
  const navigate = useNavigate();

  const handleClick = () => {
    if (href) {
      // External link - open in new tab
      window.open(href, "_blank", "noreferrer");
    } else if (route) {
      // Internal route - navigate
      navigate(route);
    }
  };

  return (
    <>
      <ListItem
        component="li"
        onClick={handleClick}
        sx={{
          cursor: "pointer",
          userSelect: "none",
          padding: 0,
          minHeight: "auto",
        }}
      >
        <SoftBox sx={(theme) => collapseItem(theme, { active, transparentSidenav })}>
          <ListItemIcon
            sx={(theme) => collapseIconBox(theme, { active, transparentSidenav, color })}
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) => collapseText(theme, { miniSidenav, transparentSidenav, active })}
          />
          
          {/* Chevron for active/collapsible item */}
          {children && (
            <SoftBox
              sx={{
                ml: "auto",
                display: "flex",
                alignItems: "center",
                color: active ? "primary.main" : "text.secondary",
              }}
            >
              <Icon fontSize="small">
                {open ? "expand_less" : "expand_more"}
              </Icon>
            </SoftBox>
          )}
        </SoftBox>
      </ListItem>
      {children && (
        <Collapse in={open} unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}


// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  open: PropTypes.bool,
  route: PropTypes.string,
  href: PropTypes.string,
};

export default SidenavCollapse;
